export function sourceAwareVideoAspectRatio(
    modelType: string | null | undefined,
    hasImageInput: boolean,
    aspectRatio: string | null | undefined,
): string | null {
    if (modelType === 'video' && hasImageInput) return null
    return aspectRatio || null
}
